import React from 'react';

export const NoPage = () => {
	return (
		<div>
			<h1 className={`header`}>There is no page in this directory</h1>
		</div>
	);
};
